import { Mask } from 'maska'
import type { MaskOptions } from 'maska'

export type MaskDeleteDirection = 'backward' | 'forward'

export function skipMaskLiterals(options: MaskOptions, value: string, caret: number, direction: MaskDeleteDirection): number {
    const mask = new Mask(options)
    const isLiteral = (index: number) => mask.unmasked(value.slice(0, index + 1)) === mask.unmasked(value.slice(0, index))
    let position = caret

    if (direction === 'backward') {
        while (position > 0 && isLiteral(position - 1)) position--
    }
    else {
        while (position < value.length && isLiteral(position)) position++
    }

    return position
}
